import type { StatusOption } from './types.js';

/**
 * The is_done flag is unset on every label of the Deliverables Status column, so the flag alone is
 * insufficient. A label is done when monday flags it so, or when it is named like a completion
 * state. This is deliberately an explicit allow-list, not "any green colour".
 */
const DONE_NAME = /^(done|completed?|shipped|released|resolved|closed)$/i;

export function isDoneLabel(label: string | null | undefined, mondayIsDone = false): boolean {
  if (!label) return false;
  return mondayIsDone || DONE_NAME.test(label.trim());
}

export function doneLabelsOf(options: StatusOption[]): string[] {
  return options.filter((o) => o.isDone).map((o) => o.label);
}
